import { createContext, PropsWithChildren } from 'react'

export const IsInArcadeModalContext = createContext(false)

export const ArcadeModalContextProvider = ({ children }: PropsWithChildren) => (
  <IsInArcadeModalContext.Provider value={true}>{children}</IsInArcadeModalContext.Provider>
)
